// extracted by css-extract-rspack-plugin
export default {"spacing":"spacing-E_RS_t","checkboxContainer":"checkboxContainer-coVBEv"};